"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var errorCollection_1 = require("./errorCollection");
var internalMonitoring_1 = require("./internalMonitoring");
var observable_1 = require("./observable");
var tracekit_1 = require("./tracekit");
var urlPolyfill_1 = require("./urlPolyfill");
var RequestType;
(function (RequestType) {
    RequestType["FETCH"] = "fetch";
    RequestType["XHR"] = "xhr";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var nextRequestId = 1;
function getNextRequestId() {
    var result = nextRequestId;
    nextRequestId += 1;
    return result;
}
var requestObservablesSingleton;
function startRequestCollection() {
    if (!requestObservablesSingleton) {
        requestObservablesSingleton = [new observable_1.Observable(), new observable_1.Observable()];
        trackXhr(requestObservablesSingleton);
        trackFetch(requestObservablesSingleton);
    }
    return requestObservablesSingleton;
}
exports.startRequestCollection = startRequestCollection;
function trackXhr(_a) {
    var requestStartObservable = _a[0], requestCompleteObservable = _a[1];
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = internalMonitoring_1.monitor(function (method, url) {
        this._datadog_xhr = {
            method: method,
            url: url,
        };
        return originalOpen.apply(this, arguments);
    });
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
        var _this = this;
        var startTime = performance.now();
        var requestId = getNextRequestId();
        requestStartObservable.notify({
            requestId: requestId,
        });
        var hasBeenReported = false;
        var reportXhr = function () {
            if (hasBeenReported) {
                return;
            }
            hasBeenReported = true;
            requestCompleteObservable.notify({
                requestId: requestId,
                startTime: startTime,
                duration: performance.now() - startTime,
                method: _this._datadog_xhr.method,
                response: _this.response,
                status: _this.status,
                traceId: getTraceId(),
                type: RequestType.XHR,
                url: urlPolyfill_1.normalizeUrl(_this._datadog_xhr.url),
            });
        };
        var originalOnreadystatechange = this.onreadystatechange;
        this.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                internalMonitoring_1.monitor(reportXhr)();
            }
            if (originalOnreadystatechange) {
                originalOnreadystatechange.apply(this, arguments);
            }
        };
        this.addEventListener('loadend', internalMonitoring_1.monitor(reportXhr));
        return originalSend.apply(this, arguments);
    };
}
exports.trackXhr = trackXhr;
function trackFetch(_a) {
    var requestStartObservable = _a[0], requestCompleteObservable = _a[1];
    if (!window.fetch) {
        return;
    }
    var originalFetch = window.fetch;
    // tslint:disable promise-function-async
    window.fetch = internalMonitoring_1.monitor(function (input, init) {
        var _this = this;
        var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
        var startTime = performance.now();
        var requestId = getNextRequestId();
        requestStartObservable.notify({
            requestId: requestId,
        });
        var reportFetch = function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var duration, url, stackTrace, text, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        duration = performance.now() - startTime;
                        url = urlPolyfill_1.normalizeUrl((typeof input === 'object' && input.url) || input);
                        if (!('stack' in response || response instanceof Error)) return [3 /*break*/, 1];
                        stackTrace = tracekit_1.computeStackTrace(response);
                        requestCompleteObservable.notify({
                            duration: duration,
                            method: method,
                            requestId: requestId,
                            startTime: startTime,
                            url: url,
                            response: errorCollection_1.toStackTraceString(stackTrace),
                            status: 0,
                            traceId: getTraceId(),
                            type: RequestType.FETCH,
                        });
                        return [3 /*break*/, 6];
                    case 1:
                        if (!('status' in response)) return [3 /*break*/, 6];
                        text = void 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.clone().text()];
                    case 3:
                        text = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        text = "Unable to retrieve response: " + e_1;
                        return [3 /*break*/, 5];
                    case 5:
                        requestCompleteObservable.notify({
                            duration: duration,
                            method: method,
                            requestId: requestId,
                            startTime: startTime,
                            url: url,
                            response: text,
                            responseType: response.type,
                            status: response.status,
                            traceId: getTraceId(),
                            type: RequestType.FETCH,
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        var responsePromise = originalFetch.call(this, input, init);
        responsePromise.then(internalMonitoring_1.monitor(reportFetch), internalMonitoring_1.monitor(reportFetch));
        return responsePromise;
    });
}
exports.trackFetch = trackFetch;
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
exports.isRejected = isRejected;
function isServerError(request) {
    return request.status >= 500;
}
exports.isServerError = isServerError;
/**
 * Get the current traceId generated from dd-trace-js (if any).
 *
 * Note: in order to work, the browser-sdk should be initialized *before* dd-trace-js because both
 * libraries are wrapping fetch() and XHR.  Wrappers are called in reverse order, and the
 * dd-trace-js wrapper needs to be called first so it can generate the new trace.  The browser-sdk
 * wrapper will then pick up the new trace id via this function.
 */
function getTraceId() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ddtrace' in window && window.ddtrace.tracer.scope().active()
        ? // tslint:disable-next-line: no-unsafe-any
            window.ddtrace.tracer
                .scope()
                .active()
                .context()
                .toTraceId()
        : undefined;
}
//# sourceMappingURL=requestCollection.js.map